import gql from 'graphql-tag';

export const CREATE_EXPERIMENT_DRAFT_MUTATION = gql`
  mutation CreateExperimentDraftMutation($experiment: CreateExperimentDraftInput!) {
    createExperimentDraft(experiment: $experiment) {
      experiment {
        id
        type
        status
      }
      errors
    }
  }
`;
